// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson <hi@ben.gy>
// Additional permissions under AGPL-3.0 section 7 — see ADDITIONAL-TERMS.md.

import { formatClock } from './format.ts';

export type EventLevel = 'info' | 'ok' | 'warn' | 'err';

export interface LogEvent {
  ts: number;
  level: EventLevel;
  msg: string;
}

const MAX_EVENTS = 500;
let events: LogEvent[] = [];
let listEl: HTMLElement | null = null;
let countEl: HTMLElement | null = null;
const listeners: Array<(e: LogEvent) => void> = [];

export function emit(level: EventLevel, msg: string): void {
  const e: LogEvent = { ts: Date.now(), level, msg };
  events.push(e);
  if (events.length > MAX_EVENTS) {
    events.shift();
    listEl?.querySelector('.event')?.remove();
  }
  if (listEl) appendRow(e);
  if (countEl) countEl.textContent = String(events.length);
  for (const l of listeners) l(e);
}

export function onEvent(fn: (e: LogEvent) => void): void {
  listeners.push(fn);
}

export function clearLog(): void {
  events = [];
  if (listEl) listEl.innerHTML = '';
  if (countEl) countEl.textContent = '0';
}

export function logText(): string {
  return events.map((e) => `[${formatClock(e.ts)}] ${e.level.toUpperCase()} ${e.msg}`).join('\n');
}

function appendRow(e: LogEvent): void {
  if (!listEl) return;
  const row = document.createElement('div');
  row.className = `event lvl-${e.level}`;
  const time = document.createElement('span');
  time.className = 'ev-time';
  time.textContent = formatClock(e.ts);
  const msg = document.createElement('span');
  msg.className = 'ev-msg';
  msg.textContent = e.msg;
  row.append(time, msg);
  listEl.appendChild(row);
  const atBottom = listEl.scrollHeight - listEl.scrollTop - listEl.clientHeight < 60;
  if (atBottom) listEl.scrollTop = listEl.scrollHeight;
}

/** Bind the drawer body elements (list + counter). */
export function bindDrawer(list: HTMLElement, count: HTMLElement): void {
  listEl = list;
  countEl = count;
  list.innerHTML = '';
  for (const e of events) appendRow(e);
  count.textContent = String(events.length);
}
